
import Component from 'vue-class-component';
import {PracticesClient, SeafaringPracticeDetailsModel} from "@/api-client";
import {Prop} from "vue-property-decorator";
import PracticeDetailsContentBase from "@/features/documents/practices/components/PracticeDetailsContentBase";
import PracticePeriodsTable from "@/features/documents/practices/components/PracticePeriodsTable.vue";
import Files from "@/components/Files.vue";
import CargoOperationsTable from "@/features/documents/practices/components/CargoOperationsTable.vue";
import HarbourVisitsTable from "@/features/documents/practices/components/HarbourVisitsTable.vue";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
  components: {
    CargoOperationsTable,
    HarbourVisitsTable,
    HeadingGroup,
    PracticePeriodsTable,
    Files
  },
})
export default class PracticeSeafaringDetailsContent extends PracticeDetailsContentBase {
  @Prop()
  details!: SeafaringPracticeDetailsModel;
  @Prop()
  isOfficial?: boolean;

  async getDownloadUrl(fileId: string): Promise<string> {
    return (await new PracticesClient().downloadSeafaringFile(this.details.id, fileId)).url;
  }
}
